import { Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

import { FleetChecklistSummary } from '../../models/fleet-checklist';
import { FleetChecklistNavigationService } from '../../services/fleet-checklist-navigation.service';

@Component({
  selector: 'app-fleet-checklist-card',
  templateUrl: './fleet-checklist-card.component.html',
  styleUrls: ['./fleet-checklist-card.component.scss', './../../styles/styles-component.scss']
})
export class FleetChecklistCardComponent implements OnInit {
  @Input() summary!: FleetChecklistSummary;
  @Output() showOptions = new EventEmitter<{
    event: MouseEvent,
    summary: FleetChecklistSummary
  }>();

  constructor(
    private navigation: FleetChecklistNavigationService
  ) { }

  ngOnInit(): void {}

  openOptionsMenu(event: any) {
    event.preventDefault();
    this.showOptions.emit({ event, summary: this.summary });
  }

  openChecklist(event: any) {
    event.preventDefault();
    this.navigation.openChecklist(this.summary.id);
  }

}
